import React, { Component } from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import HeaderData from '../../GlobalJobMatching/HeaderData/HeaderData';
import './Job.scss';

class Job extends Component {
  static propTypes = {
    className: string,
    job: shape({
      code: string,
      codeKey: string,
      currency: string,
      id: string,
      name: string
    }),
    setSelectedJob: func,
    replacementTokens: arrayOf(
      shape({
        key: string
      })
    ),
    useJobCodeKey: bool
  };

  setSelectedJob = () => {
    const { job, setSelectedJob } = this.props;

    setSelectedJob(job);
  };

  render() {
    const { className, job, replacementTokens, useJobCodeKey } = this.props;
    const orgJobCodeKey = replacementTokens.find(value => value.token === 'job_code_key_text');
    const orgJobCodeKeyLabel = orgJobCodeKey && orgJobCodeKey.value ? orgJobCodeKey.value : 'Job Code Key';

    return (
      <div className={className} key={job.id} onClick={this.setSelectedJob}>
        <div className="job__cell">
          <div className="pxl-text-small job__name">{job.org_job_title}</div>
          <div className="job__data">
            <HeaderData className="pxl-text-xsmall" label="Job Code" value={job.org_job_code} />
            {useJobCodeKey && (
              <HeaderData className="pxl-text-xsmall" label={orgJobCodeKeyLabel} value={job.org_job_code_key} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Job;
